import { render, staticRenderFns } from "./groupTableList.vue?vue&type=template&id=1d1389ab&scoped=true"
import script from "./groupTableList.vue?vue&type=script&lang=js"
export * from "./groupTableList.vue?vue&type=script&lang=js"
import style0 from "./groupTableList.vue?vue&type=style&index=0&id=1d1389ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1389ab",
  null
  
)

export default component.exports